import { getHost } from './appBridge'

export const getShopifyParams = () => {
  const params = new URLSearchParams(window.location.search)
  const shop =
    params.get('shop') ?? localStorage.getItem('shopify_shop') ?? ''
  const host = getHost()
  return { shop, host }
}

export const getShopifySessionQueryString = () => {
  const { shop, host } = getShopifyParams()
  return `embedded=1&host=${host}&name=&shop=${shop}`
}
